<template>
  <div class="password_setting">
    <div class="setting_item">
      <van-field
        v-model.trim="update.orignPassword"
        placeholder="原密码"
        :border="false"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <div class="setting_item">
      <van-field
        v-model.trim="update.password"
        placeholder="新密码"
        :border="false"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <div class="setting_item">
      <van-field
        v-model.trim="update.rePassword"
        placeholder="再次确认新密码"
        :border="false"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <div class="btn_wrapper">
      <van-button
        round
        type="info"
        size="normal"
        color="#F93244"
        @click="handleUpdate"
        :disabled="
          !update.orignPassword || !update.password || !update.rePassword
        "
        class="update_btn"
        >保存修改</van-button
      >
    </div>
  </div>
</template>

<script>
import { sipUpdatePassword } from '@/api';
export default {
  data() {
    return {
      update: {
        orignPassword: '',
        password: '',
        rePassword: ''
      }
    };
  },
  mounted() {},
  methods: {
    handleUpdate() {
      const { update } = this;
      if (update.password.trim() !== update.rePassword.trim()) {
        return this.$toast.fail('两次密码不一致');
      }
      if (update.password.trim().split('').length < 6) {
        return this.$toast.fail('密码长度至少六位');
      }
      sipUpdatePassword(update).then((res) => {
        if (res.success) {
          this.$toast.success('修改成功');
          this.update = {};
        } else {
          this.$toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.password_setting {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-top: 3.2vw;
  .setting_item {
    height: 14.933vw;
    background-color: pink;
    margin-bottom: 3.2vw;
    .item_label {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.85);
    }
    .value {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.25);
    }
  }
  .btn_wrapper {
    display: flex;
    justify-content: center;
    .update_btn {
      margin-top: 62.533vw;
      width: 91.467vw;
      height: 11.733vw;
    }
  }
}
/deep/ .van-cell {
  height: 14.933vw;
  display: flex;
  align-items: center;
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
